module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(_vm.sortedCategories) ? _c('ul', {
    attrs: {
      "id": "category-stats"
    }
  }, _vm._l((_vm.sortedCategories), function(category) {
    return _c('li', {
      key: category.id
    }, [_c('span', {
      staticClass: "color-circle",
      style: ({
        backgroundColor: category.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("\n                " + _vm._s(Math.round(category.percentage * 100)) + "%\n                " + _vm._s(category.terms.name[_vm.$locale]
      /*  TODO : Replace "category.terms.name[$locale]" by the correct trad function when the filed "value" will be in the object   */
    ) + "\n            ")])])
  })) : _vm._e(), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "components-stats"
    }
  }, [(_vm.count(_vm.allModules) > 0) ? _c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.$trad.plano.editor.infoStatistic.modules) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "quantity",
    staticStyle: {
      "color": "#99B8FA"
    }
  }, [_vm._v(_vm._s(_vm.count(_vm.allModules)) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "sku"
  }, [_vm._v("(" + _vm._s(_vm.sku(_vm.allModules)) + " SKU)")])]) : _vm._e(), _vm._v(" "), (_vm.count(_vm.allShades) > 0) ? _c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.$trad.plano.editor.infoStatistic.shades) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "quantity",
    staticStyle: {
      "color": "#FBE520"
    }
  }, [_vm._v(" " + _vm._s(_vm.count(_vm.allShades)) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "sku"
  }, [_vm._v("(" + _vm._s(_vm.sku(_vm.allShades)) + " SKU)")])]) : _vm._e(), _vm._v(" "), (_vm.count(_vm.allShelves) > 0) ? _c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.$trad.plano.editor.infoStatistic.shelves) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "quantity",
    staticStyle: {
      "color": "#955C98"
    }
  }, [_vm._v(" " + _vm._s(_vm.count(_vm.allShelves)) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.count(_vm.allCaddy) > 0) ? _c('li', [_c('span', [_vm._v(" " + _vm._s(_vm.$trad.plano.editor.infoStatistic.caddies) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "quantity",
    staticStyle: {
      "color": "#FE7B20"
    }
  }, [_vm._v(" " + _vm._s(_vm.count(_vm.allCaddy)) + " ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-736b825a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/components/infos-bar.vue
// module id = 3269
// module chunks = 0